export default "__VITE_ASSET__D4iZ2xeI__"